import {
    FACEBOOK_AD_OBJECTIVES,
    FACEBOOK_AD_OBJECTIVES_LIST,
    FACEBOOK_AD_STATUSES,
    FACEBOOK_AD_STATUSES_LIST
} from "./facebook-constant";
import {PAGE_LIMIT_LIST} from "../../design/constants/design.constant";

export const CAMPAIGN_FIELDS_LIST: any = [
    {attribute: "name", label: "Name", cssClass: '', secondaryAttributes: ['productType', 'category', 'parentProduct']},
    {attribute: "campaignId", label: "Campaign ID", cssClass: ''},
    {attribute: "objective", label: "Objective", cssClass: ''},
    {attribute: "status", label: "Status", cssClass: ''},
];


export const CAMPAIGN_INPUT_FIELDS: any = [
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: 'w-full'},
    {
        attribute: "objective",
        label: "Objective",
        type: 'select',
        readOnly: true,
        group: 'filter',
        options: FACEBOOK_AD_OBJECTIVES_LIST,
        default: 'OUTCOME_TRAFFIC',
        ccClass: 'w-1/2'
    },
    {
        attribute: 'status',
        label: 'Status',
        type: 'select',
        readOnly: true,
        group: 'filter',
        options: FACEBOOK_AD_STATUSES_LIST,
        default: 'PAUSED',
        ccClass: 'w-1/2'
    }
];


export const CAMPAIGN_FILTER_FIELDS: any = [
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: 'w-full'},
    {
        attribute: "objective",
        label: "Objective",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: FACEBOOK_AD_OBJECTIVES_LIST,
        default: 'OUTCOME_TRAFFIC',
        ccClass: 'w-1/2'
    },
    {
        attribute: 'status',
        label: 'Status',
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: FACEBOOK_AD_STATUSES_LIST,
        default: 'PAUSED',
        ccClass: 'w-1/2'
    }
];

export const DESIGN_CAMPAIGN_DASHBOARD_TABS_LIST = [
    {key: 'campaign', label: 'Campaign'},
    {key: 'designs', label: 'Designs'},
    {key: 'parent-product', label: 'Parent Product'},
    {key: 'targeting', label: 'Targeting'},
    {key: 'ad-set', label: 'Ad Sets'},
    {key: 'ad-creative', label: 'Ad Creatives'},
];

export const DEFAULT_DESIGN_CAMPAIGN_DASHBOARD_TAB = {key: 'campaign', label: 'Campaign'};

export const CAMPAIGN_DESIGN_INFO_FIELDS_LIST: any = [
    {attribute: "name", label: "Name", cssClass: '', secondaryAttributes: ['productType', 'category', 'parent']},
];

export const CAMPAIGN_DETAIL_FIELD_LIST = [
    {attribute: "name", label: "Name", cssClass: '',},
    {attribute: "campaignId", label: "Campaign ID", cssClass: ''},
    {attribute: "objective", label: "Objective", cssClass: ''},
    {attribute: "status", label: "Status", cssClass: ''},
    {attribute: "productType", label: "ProductType", cssClass: ''},
    {attribute: "category", label: "Category", cssClass: ''},
    {attribute: "parentProduct", label: "Parent Product", cssClass: ''},
];

export const CAMPAIGN_DESIGN_DETAIL_TABS_LIST = [
    {key: 'ad-sets', label: 'Ad Sets'},
    {key: 'facebook-interests', label: 'Facebook Interests'},
    {key: 'details', label: 'Details'},
];


export const DEFAULT_CAMPAIGN_DESIGN_DETAIL_TAB = {key: 'ad-sets', label: 'Ad Sets'};

export const CAMPAIGN_DESIGN_INFO_IDS_LIST = {
    DESIGN_DETAILS: "design-details",
    DESIGN_TARGETING: "design-targeting",
};

export const CAMPAIGN_DESIGN_SECONDARY_ATTRIBUTES = ['productType', 'category', 'parent']

export const PAGINATION_FIELD_LIST = [
    {
        attribute: 'limit',
        label: 'Limit',
        type: 'select',
        readOnly: false,
        group: 'pagination',
        options: PAGE_LIMIT_LIST,
        default: '10'
    },
];
